/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CountryResponse } from '../../models/country-response';

export interface CommonControllerFindCountries$Params {
  query?: string;
}

export function commonControllerFindCountries(http: HttpClient, rootUrl: string, params?: CommonControllerFindCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, commonControllerFindCountries.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CountryResponse;
      }>;
    })
  );
}

commonControllerFindCountries.PATH = '/common/countries';
